<template>
  <b-modal
    v-model="modalState.isSectionsReorderModalOpened"
    title="Edit sections order"
    ok-title="Save"
    class="modal"
    scrollable
    size="lg"
    @ok="onSaveClick"
  >
    <grid-layout
      :is-resizable="false"
      :layout.sync="dataToRender"
      :col-number="12"
      :row-height="40"
      :responsive="true"
      :is-bounded="true"
    >
      <grid-item
        v-for="item in dataToRender"
        :key="item.id"
        :x="item.x"
        :y="item.y"
        :w="item.w"
        :h="item.h"
        :i="item.i"
      >
        <font-awesome-icon
          class="icon"
          :icon="['fas', 'bars']"
        />
        <span :class="[isPlaceholder(item.Name) ? 'placeholder' : '']">
          {{ item.Name }}
        </span>
      </grid-item>
    </grid-layout>
  </b-modal>
</template>

<script>
import {createNamespacedHelpers} from 'vuex';
import {GridLayout, GridItem} from 'vue-grid-layout';

const {
  mapState: designerMapState,
  mapActions: designerMapActions,
} = createNamespacedHelpers('designer');
export default {
  name: 'SectionsReorderLayout',
  components: {
    GridLayout,
    GridItem,
  },
  data() {
    return {
      dataToRender: null,
    };
  },
  computed: {
    ...designerMapState({
      modalState: state => state,
      data: state => state.data,
    }),
  },
  methods: {
    ...designerMapActions(['saveSectionsOrdering']),
    onSaveClick() {
      this.saveSectionsOrdering(this.dataToRender);
      this.$toasted.success('Reordering successful', {duration: TOASTER_DURATION});
    },
    isPlaceholder(name) {
      return name.includes('Placeholder');
    },
  },
  beforeMount() {
    this.dataToRender = this.data.Sections.map((el, idx) => ({
      ...el,
      w: 12,
      x: idx,
      y: 0,
      h: 1,
      i: idx.toString(),
    }));
  },
};
</script>

<style scoped lang="scss">
.vue-grid-item {
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #eee;
  border-radius: 6px;
  height: 100%;
  width: 100%;
  font-size: 1em;

  & .icon {
    position: absolute;
    top: 50%;
    left: 0;
    transform: translate(50%, -50%);
  }

  & .placeholder {
    font-style: italic;
    color: #ccc;
  }

  &.vue-draggable-dragging {
    filter: invert(100%);
  }
}
</style>